import { CommunicationApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Candidate } from '../../candidates/candidate.interface';
import { Customer } from '../../customers/customer.interface';
import { Position } from '../../positions/position.interface';
import { Communication } from '../communication.interface';
import messageBulkUpdate, { MessageBulkUpdateState } from './message-bulk-is-read/message-bulk-update.store';
import { Message, MessageAssociateData } from './message.interface';
import { MessageService } from './message.service';
const service = new MessageService();

export interface MessageState {
   unreadMessages: number;
   communicationOverview?: CommunicationApiResource<Array<Message>>;
   query?: LocationQuery;
   filterData: { [key: string]: any };
   activeIndex: number;
   loadedMessages: Array<Message>;
   highlightedMessage: Message;

   //modules
   messageBulkUpdate?: MessageBulkUpdateState;
}

const MessagesStore: Module<MessageState, StoreState> = {
   namespaced: true,
   state: { filterData: {}, activeIndex: 0, loadedMessages: [], highlightedMessage: {} as Message, unreadMessages: 0 },
   getters: {},
   mutations: {
      SET_COMMUNICATION_OVERVIEW(state, communicationOverview: CommunicationApiResource<Array<Message>>) {
         state.communicationOverview = communicationOverview;
         state.loadedMessages = [];
      },
      SET_HIGHLIGHTED_MESSAGE(state, highlightedMessage: Message) {
         state.highlightedMessage = highlightedMessage;
      },
      UPDATE_LOADED_MESSAGES(state, newLoadedMessages: Array<Message>) {
         state.loadedMessages = [...newLoadedMessages];
      },
      UPDATE_COMUNICATION_OVERVIEW(state, communications: Array<Message>) {
         const data = state.communicationOverview?.data || [];

         communications.forEach((message: Message) => {
            const index = data?.findIndex((c) => c.id === message.id);
            if (!data[index]) return;
            data[index] = message;
         });
      },
      SET_QUERY(state, query?: LocationQuery) {
         state.query = query;
      },
      SET_FILTER_DATA(state, filterData: { [key: string]: any }) {
         state.filterData = filterData;
      },
      SET_FILTER_DATA_KEY(state, { key, value }: { key: string; value: Customer | Position | Candidate | number | string }) {
         state.filterData[key] = value;
      },
      RESET_FILTER_DATA(state) {
         state.filterData = {};
      },
      UPDATE_UNREAD_MESSAGES(state, unreadMessages: number) {
         if (unreadMessages < 0) {
            state.unreadMessages = 0;
            return;
         }
         state.unreadMessages = unreadMessages;
      },
   },
   actions: {
      async getMessages(context, query: LocationQuery) {
         const response = await service.getMessages(query);
         return response;
      },
      async getMessagesById(context, { message_id, query }: { message_id: number; query?: LocationQuery }) {
         const response = await service.getMessagesById(message_id, query);
         return response;
      },
      async createMessage(context, communication: Communication) {
         const response = await service.postMessage(communication);
         return response.data;
      },
      async putMessage(context, { message_id, message }: { message_id: number; message: Message }) {
         const response = await service.putMessage(message_id, message);
         return response;
      },
      async getDefaultFilters() {
         const response = await service.getDefaultFilters();
         return response;
      },
      // will not return anything 204 resopnse
      async associate(context, messageAssociateData: MessageAssociateData) {
         await service.associate(messageAssociateData);
      },
   },
   modules: {
      messageBulkUpdate,
   },
};

export default MessagesStore;
